import { useAuth } from "../contexts/AuthContext";
import { Shield, ArrowLeft, User } from "lucide-react";

/** Global banner shown at the top of every page when a master admin is
 * impersonating another user. Allows a one-click return to the admin session.
 */
export default function ImpersonationBanner() {
  const { isImpersonating, stopImpersonation, user } = useAuth();
  if (!isImpersonating) return null;
  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-[#461d8a] via-[#5b2abf] to-[#461d8a] border-b border-[#a78bfa]/30" data-testid="impersonation-banner">
      <div className="max-w-[1600px] mx-auto px-4 py-2 flex items-center gap-3">
        <div className="w-7 h-7 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0">
          <Shield className="w-3.5 h-3.5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs font-bold text-white flex items-center gap-1.5">
            Mode impersonation actif
          </div>
          <div className="text-[11px] text-white/80 truncate flex items-center gap-1">
            <User className="w-2.5 h-2.5" />
            Vous voyez la plateforme en tant que <span className="font-semibold text-white">{user?.name || user?.email}</span>
            {user?.role && <span className="text-white/60">· {user.role}</span>}
          </div>
        </div>
        <button onClick={stopImpersonation} data-testid="stop-impersonation-btn"
          className="text-[11px] font-bold px-3 py-1.5 rounded-md bg-white text-[#461d8a] hover:bg-[#f3f0ff] flex items-center gap-1 transition-colors">
          <ArrowLeft className="w-3 h-3" /> Revenir au compte admin
        </button>
      </div>
    </div>
  );
}
